export default "__VITE_ASSET__CP9NfhwX__"